import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import userManager from '../auth/oidcConfig';

export default function Callback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    userManager.signinRedirectCallback()
      .then((user) => {
        console.log('Login successful, profile:', user.profile);
        const profileComplete = user.profile?.profile_complete;
        if (!profileComplete) {
          navigate('/complete-profile');
        } else {
          navigate('/dashboard');
        }
      })
      .catch(err => {
        console.error('Callback error:', err.message);
        navigate('/');
      });
  }, [navigate]);

  return (
    <div style={{
      minHeight: '100vh', boxSizing: 'border-box',
      backgroundImage: 'url(/BESCOM_SSO_BG_Image.png)', backgroundSize: 'cover', backgroundPosition: 'center',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px',
    }}>
      <div style={{
        background: 'rgba(255, 255, 255, 0.65)', backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)',
        border: '1px solid rgba(255, 255, 255, 0.5)', borderRadius: '16px',
        padding: '32px 40px', boxShadow: '0 20px 60px rgba(0, 0, 0, 0.35)',
      }}>
        <p style={{ margin: 0, color: '#666', fontSize: '14px' }}>Authenticating...</p>
      </div>
    </div>
  );
}
